/** Converts an external failure value into the Error contract exposed by components. */
export const parseError = (cause: unknown): Error =>
  cause instanceof Error ? cause : new Error(String(cause));
